import PropTypes from "prop-types";
import React, { Component } from "react";

//Simple bar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.refDiv = React.createRef();
  }

  componentDidMount() {
    this.initMenu();
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  // componentDidUpdate() {}

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop;
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300;
          }
        }
      }
    }, 300);
  };

  activateParentDropdown = item => {
    item.classList.add("active");
    const parent = item.parentElement;

    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      this.scrollElement(item);
      return false;
    }
    this.scrollElement(item);
    return false;
  };

  render() {
    return (
      <React.Fragment>
        <SimpleBar className="h-100" ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">{this.props.t("Menu")}</li>

              <li>
                <Link to="/dashboard">
                  <i className="bx bx-home-circle" />
                  <span>{this.props.t("Dashboards")}</span>
                </Link>
              </li>

              <li>
                <Link to="/users">
                  <i className="bx bxs-user-detail" />
                  <span>{this.props.t("Users Management")}</span>
                </Link>
              </li>

              <li>
                <Link to="/products">
                  <i className="bx bxs-widget"></i>
                  <span>{this.props.t("مدیریت محصولات")}</span>
                </Link>
              </li>

              <li>
                <Link to="/categories">
                  <i className="bx bx-paperclip"></i>
                  <span>{this.props.t("مدیریت دسته بندی ها")}</span>
                </Link>
              </li>

              <li>
                <Link to="/about-us">
                  <i className="bx bx-user-pin"></i>
                  <span>{this.props.t("مدیریت درباره ما")}</span>
                </Link>
              </li>

              <li>
                <Link to="/contact-us">
                  <i className="bx bx-phone"></i>
                  <span>{this.props.t("مدیریت تماس با ما")}</span>
                </Link>
              </li>

              <li>
                <Link to="/sliders">
                  <i className="bx bx-image-alt" />
                  <span>{this.props.t("مدیریت اسلایدر")}</span>
                </Link>
              </li>

              <li>
                <Link to="/news">
                  <i className="bx bx-news"></i>
                  <span>{this.props.t("مدیریت اخبار")}</span>
                </Link>
              </li>

              <li>
                <Link to="/social">
                  <i className="bx bxl-internet-explorer"></i>
                  <span>{this.props.t("مدیریت شبکه های اجتماعی")}</span>
                </Link>
              </li>

              <li>
                <Link to="/user-comment">
                  <i className="bx bx-user-voice"></i>
                  <span>{this.props.t("مدیریت نظرات کاربران")}</span>
                </Link>
              </li>

              <li>
                <Link to="/flags">
                  <i className="bx bx-flag"></i>
                  <span>{this.props.t("مدیریت پرچم ها")}</span>
                </Link>
              </li>

              <li>
                <Link to="/brands">
                  <i className="bx bx-buoy"></i>
                  <span>{this.props.t("مدیریت برند ها")}</span>
                </Link>
              </li>

              <li>
                <Link to="/catalogs">
                  <i className="bx bxs-book-reader"></i>
                  <span>{this.props.t("مدیریت کاتالوگ")}</span>
                </Link>
              </li>

              <li>
                <Link to="/email">
                  <i className="bx bxs-book-reader"></i>
                  <span>{this.props.t("ایمیل های ثبت شده")}</span>
                </Link>
              </li>

              {/* <li>
                <Link to="/profile">
                  <i className="bx bx-user-circle" />
                  <span>{this.props.t("Profile")}</span>
                </Link>
              </li> */}

              <li>
                <Link to="/logout">
                  <i className="bx bx-log-out text-danger" />
                  <span>{this.props.t("Log Out")}</span>
                </Link>
              </li>
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withRouter(withTranslation()(SidebarContent));
